module.exports = __webpack_public_path__ + "img/progress_icon.24b2876a.svg";